<template>
  <div class="content">
    <h1>Thanks!</h1>
    <h2 v-if="reference" class="px-4">Your order reference is:<br/>#{{reference}}</h2>
    <div class="text-center px-4" v-html="compiledMarkdown" />
    

    <p v-if="is24th" class="my-4 p-4 border">Please remember to collect your cupcakes between<br><strong>10.30am-1pm</strong> on <strong>{{pickupDate}}</strong></p>
    <p v-else class="my-4 p-4 border">Please remember to collect your cupcakes between<br><strong>10.30am-2.30pm</strong> on <strong>{{pickupDate}}</strong></p>


    <div class="mt-16 mx-4">
      <h2>Before you go...</h2>
      <p>Would you like to join our mailing list?</p>
      
      <MailingList />
    </div>

  </div>
</template>


<script>
import marked from 'marked';
import { forEach } from 'lodash'
import MailingList from '../components/MailingList'
import lscache from 'lscache'
import dayjs from 'dayjs'

const specialData = require('../../functions/data/specials.json');
export default {
  computed: {
    compiledMarkdown: function () {
      return marked(this.$root.$data.images.thanks)
    },
    reference() {
      return this.$router.currentRoute.params.reference
    },
    pickupDate() {
      return dayjs(this.$router.currentRoute.params.date).format('dddd, DD MMMM YYYY')
    },
    is24th() {
      return dayjs(this.$router.currentRoute.params.date).isSame(dayjs('2020-12-24','d'))
    }
  },  
  head: {
    title() {
      return {
        inner: "Thanks"
      }
    },
  },
  components: {
    MailingList
  },
  mounted() {


    try {
      if(lscache.get('sbasket')) {
      const basket = lscache.get('sbasket')
      const products = specialData.products
      let items = []
      let total = 0 

      forEach(basket, (qty, sku) => {
        const product = products.find(p => p.sku == sku)
        total += product.amount * qty
        let litem = {
          id: `F-${product.sku}`,
          name: product.name,
          price: product.amount,
          quantity: qty,
        };

        items.push(litem)
      })

      window.gtag('event', 'purchase', {
        "transaction_id": this.$router.currentRoute.params.reference,
        "value": total,
        "currency": "GBP",
        "shipping": 0,
        "items": items
      });
      }
    } catch(e) {
      console.log(e)
    }
    lscache.remove('sbasket')
    localStorage.sorder = null
  }

}
</script>

<style>

</style>